export default __webpack_public_path__ + "static/media/original.811ad013.jpg";